export default __webpack_public_path__ + "static/media/5.22e61340.gif";